import React, { useEffect, useRef, useState } from "react";
import { api } from "../../../middleware/api";
import {
  UtilityFunctions,
  modifiedSalaray,
} from "../../../utils/UtilityFunctions";
import { actionCreators, State } from "../../../store";
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import { cookieService, userService } from "../../../_services";
import { STRING_CONSTANTS } from "../../../utils/constants/stringConstants";
import SuccessToast from "../../../components/successToast";
import ValidationErrorToast from "../../../components/validationErrorToast";
import { END_POINTS } from "../../../utils/constants/endPoints";
import { Data, User } from "../../../_services/collections";
import { Link } from "react-router-dom";
import NoVerifyModal from "../../../components/noVerifyModal";
const debounce = require("debounce-promise");
const Employees = (props: any) => {
  const dispatch = useDispatch();
  const {
    setEmployeesList,
    setSidebar,
    setRemoveEmployee,
    setResetJob,
    setJobsList,
  } = bindActionCreators(actionCreators, dispatch);
  const reduxState = useSelector((state: State) => state);
  const state = useSelector((state: State) => state);
  const scrollRef = useRef<any>();
  const [nextURL, setNextURL] = useState("");
  const [activeJobList, setActiveJobList] = useState([]);
  const [currentJob, setCurrentJob] = useState<any>();
  const [scrollWidth, setScrollWidth] = useState<any>();
  const [notVerifiedModal, setNotVerifiedModal] = useState(false);
  const verified = cookieService.getCookie(STRING_CONSTANTS.cookieStrings.user)
    ?.user?.isVerified;
  useEffect(() => {
    if (
      props?.isUserLoggedIn &&
      props.userType === STRING_CONSTANTS.userType.employer
    )
      getAllActiveJobs(); // Comment: added employer condition as per backend team discussion
  }, []);
  const getAllActiveJobs = () => {
    api
      .get("jobs/active/", null)
      .then((res) => {
        // console.log("employee-list " + res);
        setActiveJobList(res);
        if (props?.selectedJobID) {
          props?.setSelectedJobID(props?.selectedJobID);
        }
        else {
          props?.setSelectedJobID(res?.[0]?.id);
        }
        props?.setEmployeeJobList(res);
        if (res[0] !== undefined) {
          props?.setEmployeeObject(res[0]);
        } else {
          props?.setEmployeeObject(null);
        }
        debounceClick();
      })
      .catch();
  };

  useEffect(() => {
    !props.isUserLoggedIn && checkLocationPermission();
  }, [props.coords]);

  async function checkLocationPermission() {
    document.body.classList.add("loading-indicator");
    await navigator.permissions
      .query({ name: "geolocation" })
      .then((result) => {
        if (result.state === "granted" && props?.coords) {
          getMatchedEmployees();
          // setLocationPermission(true)
        } else if (result.state === "prompt") {
          getMatchedEmployees();
          // setLocationPermission(false)
        } else if (result.state === "denied") {
          getMatchedEmployees();
          // setLocationPermission(false)
        }
      });
  }

  //activating scroll only when employee list generates
  // useEffect(() => {
  //     handleScroll()
  // }, [])

  useEffect(() => {
    setResetJob(null);
  }, []);

  const getMatchedEmployees = () => {
    if (!props?.isUserLoggedIn) {
      if (props?.coords) {
        api
          .post(
            `jobs/?limit=10&lat=${props?.coords?.lat}&long=${props.coords.long}`,
            null
          )
          .then((res: any) => {
            setEmployeesList(res?.data?.results);
            setNextURL(res?.data?.next);
          })
          .catch((e) => {
            setEmployeesList([]);
          });
      } else {
        api
          .post(`jobs/?limit=10`, null)
          .then((res: any) => {
            setEmployeesList(res?.data?.results);
            setNextURL(res?.data?.next);
          })
          .catch((e) => {
            setEmployeesList([]);
          });
      }
    } else if (
      props?.selectedJobID &&
      activeJobList &&
      props.userType === STRING_CONSTANTS.userType.employer
    ) {
      api
        .get(
          `employee/all/?limit=10&relatedToJobs=true&jobId=${props?.selectedJobID || activeJobList?.[0]?.id
          }&sort=${props?.closest ? "distance" : "-relevance"
          }&sort=user__first_name&sort=user__last_name${props.requestReceived ? "&requestReceived=true" : ""
          }${props.requestSent ? "&requestSent=true" : ""}&distance=${props.requestDistance ? (props.requestDistance >= 50 ? "" : props.requestDistance) : 25}`,
          null
        )
        .then((res: any) => {
          setEmployeesList(res.results);
          setNextURL(res.next);
        })
        .catch((e) => {
          setEmployeesList([]);
        });
    } else if (props.userType === STRING_CONSTANTS.userType.employee) {
      setNextURL("");
      api
        .post(
          `employee/jobs/?limit=10
          &sort=${props?.closest ? "distance" : "-relevance"
          }&relatedToJobs=true${props.requestReceived ? "&requestReceived=true" : ""
          }${props.requestSent ? "&requestSent=true" : ""}&distance=${props.requestDistance ? props.requestDistance : ""}`,
          null
        )
        .then((res: any) => {
          setEmployeesList(res?.data?.results);
          res?.data?.next != null && setNextURL(res?.data?.next);
        })
        .catch((e) => {
          setEmployeesList([]);
        });
    }
  };

  const handleScroll = () => {
    var store = scrollRef?.current;
    if (store) {
      const { scrollLeft = 0, scrollWidth = 0, clientWidth = 0 } = store;
      setScrollWidth(scrollWidth + 1);
      let isAtRightEnd = scrollLeft + clientWidth + 1 >= scrollWidth;
      // when user hits the end of scroll, API for the next set of results(nextURL) is called
      if (
        nextURL &&
        (scrollLeft + clientWidth === scrollWidth || isAtRightEnd)
      ) {
        const nextPage = nextURL?.split(UtilityFunctions.API_URL())?.[1];
        if (!props?.isUserLoggedIn) {
          api.post(nextPage, null).then((res: any) => {
            setNextURL(res.data.next);
            setEmployeesList([
              ...reduxState.employeesList,
              ...res?.data?.results,
            ]);
          });
        } else if (props.userType === STRING_CONSTANTS.userType.employer) {
          api.get(nextPage, null).then((res) => {
            setNextURL(res.next);
            setEmployeesList([...reduxState.employeesList, ...res.results]);
          });
        } else if (props.userType === STRING_CONSTANTS.userType.employee) {
          document.body.classList.add("loading-indicator");
          api.post(nextPage, null).then((res: any) => {
            setNextURL(res.data.next);
            setEmployeesList([
              ...reduxState.employeesList,
              ...res?.data?.results,
            ]);
          });
        }
      }
    }
  };

  const debounceClick = debounce(() => {
    handleScroll()
  }, 600);
  const debounceClickButtonLeft = debounce(() => {
    scrollRef.current.scroll({
      left: scrollRef?.current?.scrollLeft - 700,
      behavior: "smooth",
    });
  }, 100);
  const debounceClickButtonRight = debounce(() => {
    scrollRef.current.scroll({
      left: scrollRef?.current?.scrollLeft + 700,
      behavior: "smooth",
    });
  }, 100);

  useEffect(() => {
    // console.log(props?.selectedJobID, props?.closest, props?.requestReceived, props?.requestSent, activeJobList)
    if (
      activeJobList.length > 0 &&
      props?.selectedJobID &&
      props.userType === STRING_CONSTANTS.userType.employer
    ) {
      getMatchedEmployees();
    }
    // added below condition for mploi only as we can not call active job api for mploi end. as per backend team discussion.
    else if (props.userType === STRING_CONSTANTS.userType.employee) {
      getMatchedEmployees();
    } else setEmployeesList([]);
  }, [
    props?.selectedJobID,
    props?.closest,
    props?.requestReceived,
    props?.requestSent,
    props?.requestDistance,
    activeJobList,
  ]);

  useEffect(() => {
    setCurrentJob(
      activeJobList?.find((job) => job?.id === props?.selectedJobID)
    );
  }, [activeJobList, props?.selectedJobID]);

  const handleSendRequest = (employee) => {
    const erID = cookieService.getCookie(
      STRING_CONSTANTS.cookieStrings.user
    ) as Data;
    const eeList = [...reduxState.employeesList];
    eeList.splice(
      reduxState.employeesList.findIndex((ee) => ee.id == employee.id),
      1,
      { ...employee, chatRequested: true, requestedByUser: true }
    );
    // if (!employee?.chatRequested) {
    let params = {};
    if (props.userType === STRING_CONSTANTS.userType.employer) {
      // employer
      params = {
        employerId: erID.user.id,
        employeeId: employee?.user?.id,
        jobId: currentJob?.id,
      };
    } else {
      // employee
      params = {
        employerId: `${employee?.employer?.user?.id}`,
        employeeId: `${erID.user.id}`,
        jobId: `${employee?.id}`,
      };
    }
    api
      .post("chat/rooms/", params)
      .then((res) => {


        console.log("chat res", res);
        // setEmployeesList(eeList);
        // SuccessToast("Chat Request Sent", "");
        props.history.push(`/dashboard/chat?chatid=${res?.data?.room?.id}`);

      })
      .catch((e) => {
        ValidationErrorToast(
          "Error occured!",
          "Please try again after some time"
        );
        // console.log(e)
      });
    // }
  };

  // const handleReceivedRequest = {
  //   handleChatAccept: (employee) => {
  //     api
  //       .patch(`${employee?.chatRoomId}/chat/`, {
  //         isActive: true,
  //       })
  //       .then((res) => {
  //         // console.log(res?.data)
  //         SuccessToast(
  //           "Chat Request Accepted",
  //           "Request has been successfully accepted"
  //         );
  //         setRemoveEmployee(employee);
  //         props.history.push(`/dashboard/chat?chatid=${res?.data?.["id"]}`);
  //       })
  //       .catch((e) => {
  //         ValidationErrorToast(
  //           "Error occured!",
  //           "Please try again after some time"
  //         );
  //         // console.log(e)
  //       });
  //   },
  //   handleChatReject: (employee) => {
  //     api
  //       .patch(`${employee?.chatRoomId}/chat/`, {
  //         isActive: false,
  //       })
  //       .then((res) => {
  //         // console.log(res)
  //         SuccessToast("Chat Request Rejected", "Request has been rejected");
  //         setRemoveEmployee(employee);
  //       })
  //       .catch((e) => {
  //         ValidationErrorToast(
  //           "Error occured!",
  //           "Please try again after some time"
  //         );
  //         // console.log(e)
  //       });
  //   },
  // };


  // console.log(reduxState, "redux");

  const renderEmployeesList = reduxState?.employeesList?.map(
    (employee, index) => {
      if (!props?.isUserLoggedIn && (index + 1) % 21 === 0) {
        return (
          <div className="myforst-card-setup text-center ms-0">
            <div className="inner-first-data">
              <img
                src={UtilityFunctions.getImageURL() + "refine-job.png"}
                alt=""
                style={{ maxWidth: "104px" }}
              />
              <h5>Refine Job Listings</h5>
              <p>
                Refine your job searches by creating an account and adding your
                qualifications for maximum results
              </p>
              <div className="btn-nextSkip justify-content-center">
                <button
                  className="next-btn"
                  onClick={() =>
                    props.history.push({
                      pathname: STRING_CONSTANTS.navigationString.signup,
                      state: { isGuest: true },
                    })
                  }
                >
                  {STRING_CONSTANTS.onboardingScreen.buttons.signup}
                </button>
              </div>
            </div>
          </div>
        );
      } else
        return (
          // color hear employee background color change
          // light-gray-bg
          // light-perple-bg
          <div
            className={`employee-card ${employee?.user?.referralUsedCount >= 0 ? "light-perple-bg" : ""
              }`}
            // className={`employee-card light-perple-bg `}
            key={employee?.id}
          >
            {employee?.user?.referralUsedCount >= 0 ? (
              <div className="advansed-user d-flex align-items-center gap-1">
                <img
                  src={UtilityFunctions.getImageURL() + "mdi_star-shooting.png"}
                  alt=""
                />
                <p className="mb-0">Advanced User</p>
              </div>
            ) : (
              <div></div>
            )}
            <div
              className="photo-wrap"
              data-bs-toggle="modal"
              data-bs-target="#staticBackdrop"
              onClick={() => {
                setSidebar({
                  sidebar_name: "employee-details",
                  show_sidebar: true,
                });
                props?.setSelectedEmployee(employee);
              }}
            >
              {props.userType === STRING_CONSTANTS.userType.employer ? (
                <img
                  src={
                    employee?.profilePhoto
                      ? employee?.profilePhoto
                      : UtilityFunctions.getImageURL() + "employee-pic.jpg"
                  }
                />
              ) : (
                <img
                  src={
                    employee?.cover
                      ? employee?.cover
                      : UtilityFunctions.getImageURL() +
                      "dashboard-profile-pic.png"
                  }
                />
              )}
              <div className="over-content">
                <div className="content-top">
                  <div className="left-name">
                    {props.userType === STRING_CONSTANTS.userType.employer ? (
                      <h3>I’m interested in your…</h3>
                    ) : (
                      <h3>I’m looking for a…</h3>
                    )}
                    {props.userType === STRING_CONSTANTS.userType.employer ? (
                      <h2>{currentJob?.title}</h2>
                    ) : (
                      <h2>{employee?.title}</h2>
                    )}
                  </div>
                  {/* {employee?.isAgeVerified ?
                                <div className='right-age'> Age
                                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M15.0023 1.09768L15.1169 1.32652L15.9816 3.626C16.0495 3.80708 16.1924 3.94997 16.3735 4.0179L18.5936 4.85081C19.5679 5.21632 20.0914 6.25738 19.8318 7.24236L19.7693 7.43839L18.7365 9.72263C18.6565 9.89871 18.6565 10.1008 18.7365 10.2769L19.7174 12.4357C20.1478 13.383 19.7819 14.4894 18.9018 15.0023L18.673 15.1169L16.3735 15.9816C16.1924 16.0495 16.0495 16.1924 15.9816 16.3735L15.1487 18.5936C14.7832 19.5679 13.7421 20.0914 12.7571 19.8318L12.5611 19.7693L10.2769 18.7365C10.1008 18.6565 9.89871 18.6565 9.72263 18.7365L7.56382 19.7174C6.61646 20.1478 5.51013 19.7819 4.99721 18.9018L4.88258 18.673L4.0179 16.3735C3.94997 16.1924 3.80708 16.0495 3.626 15.9816L1.40589 15.1487C0.431631 14.7832 -0.0919035 13.7421 0.167708 12.7571L0.23017 12.5611L1.26302 10.2769C1.34303 10.1008 1.34303 9.89871 1.26302 9.72263L0.282123 7.56382C-0.148326 6.61646 0.217617 5.51013 1.09768 4.99721L1.32652 4.88258L3.626 4.0179C3.80708 3.94997 3.94997 3.80708 4.0179 3.626L4.85081 1.40589C5.21632 0.431631 6.25738 -0.0919035 7.24236 0.167708L7.43839 0.23017L9.72263 1.26302C9.89871 1.34303 10.1008 1.34303 10.2769 1.26302L12.4357 0.282123C13.383 -0.148326 14.4894 0.217617 15.0023 1.09768ZM13.2456 6.55861L8.46712 12.0197L6.72344 10.2761C6.46183 10.0144 6.03767 10.0144 5.77605 10.2761C5.51444 10.5377 5.51444 10.9618 5.77605 11.2234L8.02605 13.4734C8.30007 13.7475 8.74872 13.7325 9.0039 13.4409L14.2539 7.44088C14.4975 7.16245 14.4693 6.73923 14.1909 6.49559C13.9124 6.25196 13.4892 6.28018 13.2456 6.55861Z" fill="white" />
                                    </svg>
                                </div>
                                : ""} */}
                </div>
                <div className="content-bottom">
                  {props.userType === STRING_CONSTANTS.userType.employer ? (
                    <h4>
                      {employee?.user?.firstName || ""}
                      {/* <span className="level-check-perple">LVL 2</span> */}
                      {employee?.isAgeVerified ? (
                        <div className="right-age">
                          {/* <svg width="16" height="16" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M15.0023 1.09768L15.1169 1.32652L15.9816 3.626C16.0495 3.80708 16.1924 3.94997 16.3735 4.0179L18.5936 4.85081C19.5679 5.21632 20.0914 6.25738 19.8318 7.24236L19.7693 7.43839L18.7365 9.72263C18.6565 9.89871 18.6565 10.1008 18.7365 10.2769L19.7174 12.4357C20.1478 13.383 19.7819 14.4894 18.9018 15.0023L18.673 15.1169L16.3735 15.9816C16.1924 16.0495 16.0495 16.1924 15.9816 16.3735L15.1487 18.5936C14.7832 19.5679 13.7421 20.0914 12.7571 19.8318L12.5611 19.7693L10.2769 18.7365C10.1008 18.6565 9.89871 18.6565 9.72263 18.7365L7.56382 19.7174C6.61646 20.1478 5.51013 19.7819 4.99721 18.9018L4.88258 18.673L4.0179 16.3735C3.94997 16.1924 3.80708 16.0495 3.626 15.9816L1.40589 15.1487C0.431631 14.7832 -0.0919035 13.7421 0.167708 12.7571L0.23017 12.5611L1.26302 10.2769C1.34303 10.1008 1.34303 9.89871 1.26302 9.72263L0.282123 7.56382C-0.148326 6.61646 0.217617 5.51013 1.09768 4.99721L1.32652 4.88258L3.626 4.0179C3.80708 3.94997 3.94997 3.80708 4.0179 3.626L4.85081 1.40589C5.21632 0.431631 6.25738 -0.0919035 7.24236 0.167708L7.43839 0.23017L9.72263 1.26302C9.89871 1.34303 10.1008 1.34303 10.2769 1.26302L12.4357 0.282123C13.383 -0.148326 14.4894 0.217617 15.0023 1.09768ZM13.2456 6.55861L8.46712 12.0197L6.72344 10.2761C6.46183 10.0144 6.03767 10.0144 5.77605 10.2761C5.51444 10.5377 5.51444 10.9618 5.77605 11.2234L8.02605 13.4734C8.30007 13.7475 8.74872 13.7325 9.0039 13.4409L14.2539 7.44088C14.4975 7.16245 14.4693 6.73923 14.1909 6.49559C13.9124 6.25196 13.4892 6.28018 13.2456 6.55861Z" fill="white" />
                                            </svg> */}
                          <img
                            src={
                              UtilityFunctions.getImageURL() +
                              "checkmark-starburst.svg"
                            }
                            alt=""
                          />
                          Age
                        </div>
                      ) : (
                        ""
                      )}
                    </h4>
                  ) : !props?.isUserLoggedIn ? (
                    <h4>{employee?.employerName}</h4>
                  ) : (
                    <h4>{employee?.employer?.tradingName}</h4>
                  )}
                  <h5>
                    {/* <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <g opacity="0.8">
                                        <path d="M5.85435 5.19961C5.98875 4.50115 6.17127 3.87376 6.38958 3.34358C6.63114 2.75693 6.90865 2.30852 7.19633 2.01301C7.48279 1.71876 7.75409 1.59961 7.99961 1.59961C8.24512 1.59961 8.51643 1.71876 8.80288 2.01301C9.09057 2.30852 9.36808 2.75693 9.60964 3.34358C9.82795 3.87376 10.0105 4.50115 10.1449 5.19961H5.85435ZM5.64984 3.03898C5.8399 2.57741 6.06116 2.16541 6.31204 1.82444C4.52047 2.31291 3.04189 3.5602 2.243 5.19961H5.04057C5.18613 4.39367 5.39325 3.66213 5.64984 3.03898ZM10.3494 3.03898C10.1593 2.57741 9.93806 2.16541 9.68718 1.82445C11.4788 2.31291 12.9573 3.5602 13.7562 5.19961H10.9587C10.8131 4.39367 10.606 3.66213 10.3494 3.03898ZM11.0796 5.99961H14.0809C14.2877 6.62885 14.3996 7.30116 14.3996 7.99961C14.3996 8.02366 14.3995 8.04767 14.3992 8.07166C13.7478 7.52776 12.9146 7.19961 11.9996 7.19961C11.7194 7.19961 11.4468 7.23039 11.1848 7.28871C11.1664 6.84649 11.1308 6.41546 11.0796 5.99961ZM8.20979 10.7996C8.20304 10.894 8.19961 10.9893 8.19961 11.0853C8.19961 11.9569 8.53069 12.7936 9.11368 13.6006C9.01229 13.7492 8.90827 13.878 8.80288 13.9862C8.51643 14.2805 8.24512 14.3996 7.99961 14.3996C7.75409 14.3996 7.48279 14.2805 7.19633 13.9862C6.90865 13.6907 6.63114 13.2423 6.38958 12.6556C6.17127 12.1255 5.98875 11.4981 5.85435 10.7996H8.20979ZM8.35049 9.99961C8.65685 8.92324 9.40725 8.03253 10.3938 7.56172C10.3792 7.01902 10.3378 6.49577 10.2733 5.99961H5.72595C5.64417 6.628 5.59961 7.29985 5.59961 7.99961C5.59961 8.69937 5.64417 9.37121 5.72595 9.99961H8.35049ZM2.243 10.7996C3.04189 12.439 4.52047 13.6863 6.31203 14.1748C6.06116 13.8338 5.8399 13.4218 5.64984 12.9602C5.39325 12.3371 5.18613 11.6055 5.04057 10.7996H2.243ZM4.91958 9.99961H1.91831C1.71149 9.37037 1.59961 8.69806 1.59961 7.99961C1.59961 7.30116 1.71149 6.62885 1.91831 5.99961H4.91958C4.84129 6.63553 4.79961 7.30694 4.79961 7.99961C4.79961 8.69228 4.84129 9.36369 4.91958 9.99961ZM11.9996 7.99961C13.6565 7.99961 14.9996 9.38113 14.9996 11.0853C14.9996 12.3625 14.0531 13.7012 12.1996 15.131C12.0811 15.2225 11.9181 15.2225 11.7996 15.131C9.94614 13.7012 8.99961 12.3625 8.99961 11.0853C8.99961 9.38113 10.3428 7.99961 11.9996 7.99961ZM11.9996 10.0568C11.4473 10.0568 10.9996 10.5173 10.9996 11.0853C10.9996 11.6534 11.4473 12.1139 11.9996 12.1139C12.5519 12.1139 12.9996 11.6534 12.9996 11.0853C12.9996 10.5173 12.5519 10.0568 11.9996 10.0568Z" fill="white" />
                                    </g>
                                </svg> */}
                    <img
                      src={
                        UtilityFunctions.getImageURL() + "Globe Location.svg"
                      }
                      className="global-lock"
                      alt=""
                    />
                    {(employee?.location?.suburb
                      ? employee?.location?.suburb
                      : "") +
                      (employee?.location?.state ? ", " : "") +
                      (employee?.location?.state
                        ? employee?.location?.state
                        : "")}

                    {(props.userType === STRING_CONSTANTS.userType.employee ||
                      props.userType == null) && (
                        <>
                          {/* <svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ marginTop: 7, marginLeft: 10 }}>
                                            <path d="M1.5 0C0.671573 0 0 0.671573 0 1.5V8.5C0 9.32843 0.671573 10 1.5 10H12.5C13.3284 10 14 9.32843 14 8.5V1.5C14 0.671573 13.3284 0 12.5 0H1.5ZM4 1V2C4 3.10457 3.10457 4 2 4L1 4V3H2C2.55228 3 3 2.55228 3 2V1H4ZM7 6.75C6.0335 6.75 5.25 5.9665 5.25 5C5.25 4.0335 6.0335 3.25 7 3.25C7.9665 3.25 8.75 4.0335 8.75 5C8.75 5.9665 7.9665 6.75 7 6.75ZM1 7V6H2C3.10457 6 4 6.89543 4 8V9H3V8C3 7.44772 2.55228 7 2 7H1ZM12 7C11.4477 7 11 7.44772 11 8V9H10V8C10 6.89543 10.8954 6 12 6H13V7H12ZM12 3H13V4L12 4C10.8954 4 10 3.10457 10 2V1H11V2C11 2.55228 11.4477 3 12 3ZM15.0001 8.49997C15.0001 9.88069 13.8808 11 12.5001 11H2.08545C2.29137 11.5826 2.84699 12 3.5001 12H12.5001C14.4331 12 16.0001 10.433 16.0001 8.49997V3.49997C16.0001 2.84686 15.5827 2.29125 15.0001 2.08533V8.49997Z" fill="white" />
                                    </svg> */}
                          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                          <img
                            src={UtilityFunctions.getImageURL() + "money.svg"}
                            alt=""
                          />
                          {modifiedSalaray(
                            employee?.minSalary,
                            employee?.maxSalary,
                            null,
                            employee?.salaryCheckoutType
                          )}
                          {/* {
                                            (employee.minSalary >= 1000 ? '$' + Math.round(employee.minSalary / 1000) + 'k' : '$' + Math.round(employee.minSalary)) +
                                            "-" +
                                            (employee.maxSalary >= 1000 ? '$' + Math.round(employee.maxSalary / 1000) + 'k' : '$' + Math.round(employee.maxSalary))
                                        } */}
                        </>
                      )}
                  </h5>
                </div>
              </div>
            </div>
            <div className="button-wrap">
              {
                // (employee?.chatRequested &&
                //                 employee?.requestedByUser === false && (
                //                   <>
                //                     <button
                //                       className="reject-btn"
                //                       type="button"
                //                       onClick={() =>
                //                         handleReceivedRequest.handleChatReject(employee)
                //                       }
                //                     >
                //                       Reject
                //                     </button>
                //                     <div className="btn-effect">
                //                       <button
                //                         className="chat-btn"
                //                         type="button"
                //                         onClick={() =>
                //                           handleReceivedRequest.handleChatAccept(employee)
                //                         }
                //                       >
                //                         Chat
                //                       </button>
                //                     </div>
                //                   </>
                //                 )) 
                // ||
                //                 (employee?.chatRequested &&
                //                   employee?.requestedByUser === true && (
                //                     <div className="btn-effect full-width-btn v-disabled-btn">
                //                       <button className="chat-btn" disabled type="button">
                //                         Chat Request Sent
                //                       </button>
                //                     </div>
                //                   )) 
                // ||
                (employee?.chatRoomId &&
                  (
                    <div className="btn-effect full-width-btn " style={{ backgroundColor: "#FFB800", color: "black" }}>
                      <button className="chat-btn" type="button" style={{ color: "black" }} onClick={() => {
                        props.history.push(`/dashboard/chat?chatid=${employee?.chatRoomId}`)
                      }} >
                        Ongoing Chat, Click Here
                      </button>
                    </div>
                  ))
                ||
                (
                  <div className={`btn-effect full-width-btn`}>
                    <button
                      className="chat-btn"
                      type="button"
                      onClick={() => {
                        if (!props?.isUserLoggedIn) {
                          props?.setShowGuestAccessPrompt(true);
                        } else if (!verified) {
                          setNotVerifiedModal(true);
                        } else {
                          handleSendRequest(employee);
                          // props.history.push(`/dashboard/chat`);
                        }
                      }}
                      style={{ color: "black" }}
                    >
                      {/* Send Chat Request */}
                      Start Chat
                    </button>
                  </div>
                )}
            </div>
          </div>
        );
    }
  );
  const handleClose = () => {
    setNotVerifiedModal(false);
  };
  return (
    <>
      <NoVerifyModal show={notVerifiedModal} handleClose={handleClose} />
      <div className="employe-wrap">
        {reduxState.employeesList?.length ? (
          <div className="employe-gradient">
            <div
              className="employe-scroll"
              ref={scrollRef}
              onScroll={() => debounceClick()}
            >
              {!props?.isUserLoggedIn ? (
                <>
                  {/* <div className="myforst-card-setup text-center">
                                    <div className="inner-first-data">
                                        <img src={UtilityFunctions.getImageURL() + "refine-job.png"} alt="" style={{ maxWidth: '104px' }} />
                                        <h5>Refine Job Listings</h5>
                                        <p>Refine your job searches by creating an account and adding your qualifications for maximum results</p>
                                        <div className="btn-nextSkip">
                                            <Link className="mx-auto" to={STRING_CONSTANTS.navigationString.signup}>
                                                <button className="next-btn">
                                                    {STRING_CONSTANTS.onboardingScreen.buttons.signup}
                                                </button>
                                            </Link>
                                        </div>
                                    </div>
                                </div> */}
                  {renderEmployeesList}
                </>
              ) : !verified ? (
                <>
                  {/* <div className="myforst-card-setup text-center">
                    <div className="inner-first-data">
                      <img
                        src={
                          UtilityFunctions.getImageURL() + "your-account.png"
                        }
                        alt=""
                      />
                      <h5>Your account is currently being reviewed</h5>
                      <p>
                        During this time you won’t have the ability to post jobs
                        or message users. You will be notified when the MPLOI
                        team approves your account.{" "}
                      </p>
                    </div>
                  </div> */}
                  {renderEmployeesList}{" "}
                </>
              ) : (
                <>
                  {props.userType === STRING_CONSTANTS.userType.employee && (
                    <div className="myforst-card-setup update-match text-center">
                      <div className="inner-first-data">
                        <img
                          src={
                            UtilityFunctions.getImageURL() +
                            "pencil-add-round-bold.svg"
                          }
                          alt=""
                        />
                        <h5>Update Match Results?</h5>
                        <p>
                          Edit match results by pressing the update button below
                          to change your preferences
                        </p>
                      </div>
                    </div>
                  )}
                  {renderEmployeesList}

                </>
              )}
            </div>
            {/* {(verified || !props?.isUserLoggedIn) ? */}
            <div className="employe-gradient-arrow-button">
              <div
                onClick={() => {
                  debounceClickButtonLeft()
                  //   scrollRef.current.scroll({
                  //     left: scrollRef?.current?.scrollLeft - 700,
                  //     behavior: "smooth",
                  //   });
                }}
              >
                {/* <svg width="11" height="20" viewBox="0 0 11 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M10.4571 19.7071C10.0666 20.0976 9.43342 20.0976 9.04289 19.7071L0.292892 10.9571C0.105356 10.7696 -1.07816e-06 10.5152 -1.05498e-06 10.25C-1.03179e-06 9.98478 0.105356 9.73043 0.292892 9.54289L9.04289 0.792892C9.43342 0.402368 10.0666 0.402368 10.4571 0.792892C10.8476 1.18342 10.8476 1.81658 10.4571 2.20711L2.41421 10.25L10.4571 18.2929C10.8476 18.6834 10.8476 19.3166 10.4571 19.7071Z" fill="white" />
                            </svg> */}
                <img
                  src={
                    UtilityFunctions.getImageURL() + "chevron-arrow-left.svg"
                  }
                  alt=""
                />
              </div>
              <div
                onClick={() => {
                  debounceClickButtonRight()

                }}
              >
                {/* <svg width="11" height="20" viewBox="0 0 11 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M0.542893 0.292893C0.933418 -0.0976308 1.56658 -0.0976308 1.95711 0.292893L10.7071 9.04289C10.8946 9.23043 11 9.48479 11 9.75C11 10.0152 10.8946 10.2696 10.7071 10.4571L1.9571 19.2071C1.56658 19.5976 0.933415 19.5976 0.542891 19.2071C0.152367 18.8166 0.152367 18.1834 0.542891 17.7929L8.58579 9.75L0.542893 1.70711C0.152369 1.31658 0.152369 0.683419 0.542893 0.292893Z" fill="white" />
                            </svg> */}
                <img
                  src={
                    UtilityFunctions.getImageURL() + "chevron-arrow-right.svg"
                  }
                  alt=""
                />
              </div>
            </div>
            {/* : <div></div>} */}
          </div>
        ) : (
          <div className="no-table-data no-table-one">
            {props.userType === STRING_CONSTANTS.userType.employer ? (
              <div>
                <div className="arrow-inner">
                  <img
                    src={UtilityFunctions.getImageURL() + "pointing-arrow.png"}
                    alt=""
                  />
                </div>
                <div>
                  <img
                    src={UtilityFunctions.getImageURL() + "no-data.svg"}
                    alt=""
                  />
                  <p>
                    It looks like you haven’t listed any active jobs yet. Tap
                    the plus to create your first job listing.
                  </p>
                </div>
              </div>
            ) : (
              <div className="employee-empty">

                <div>
                  <img
                    src={UtilityFunctions.getImageURL() + "no-data.svg"}
                    alt=""
                  />
                  <p>It looks like there are no matching jobs yet.</p>
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    </>
  );
};

export default Employees;
